// @ts-check
import axios from "axios";
import keycloak from "../keycloak-config";

const API_URL = process.env.API_URL;

console.log("keycloak token", keycloak.token);
const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    if (keycloak.token) {
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export default api;
